// Pure route matcher for the practice-plan pages. Exact hub paths are tested
// before the 36-character id match, so a tab name can never be read as an id.

const TABS = { '/plans': 'upcoming', '/plans/templates': 'templates', '/plans/blocks': 'blocks' };
const PLAN_ID = /^\/plans\/([0-9a-f-]{36})$/i;
const OCCURRENCE = /^\/practices\/([0-9a-f-]{36})\/plan$/i;

export function resolvePlanRoute(path) {
  if (typeof path !== 'string') return null;
  const p = path.split(/[?#]/)[0];
  if (Object.hasOwn(TABS, p)) return { kind: 'hub', tab: TABS[p] };
  const plan = PLAN_ID.exec(p);
  if (plan) return { kind: 'plan', planId: plan[1] };
  const occ = OCCURRENCE.exec(p);
  if (occ) return { kind: 'occurrence', occurrenceId: occ[1] };
  return null;
}

// Routes that render without the app shell (public pages). The off-season modal
// belongs to the signed-in shell and must not open over them.
export function isShellLessRoute(path) {
  if (typeof path !== 'string') return false;
  const p = path.startsWith('#') ? path.slice(1) : path;
  return p.startsWith('/plan/') || p.startsWith('/trainer/');
}
